<template>
  <b-modal
    id="upload-badge-modal"
    title="Upload Image"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    @hide="croppa ? croppa.remove : null"
  >
    <div class="border mx-auto rounded-circle upload-container" >
      <croppa
        v-model="croppa"
        @new-image-drawn="onNewBadge"
        @zoom="onBadgeZoom"
        :width="200"
        :height="200"
        placeholder="Choose an Image"
        :show-remove-button="true"
        :placeholder-font-size="14"
        remove-button-color="#ff8828"
      ></croppa>
    </div>
    <div id="logo-stamp-range-container" class="mx-auto mt-2">
      <input
        type="range"
        class="custom-range"
        id="customRange2"
        @input="onBadgeSliderChange"
        :min="sliderMin"
        :max="sliderMax"
        step=".001"
        v-model="sliderVal"
      />
    </div>
    <div slot="modal-footer">
      <b-button
        variant="ghost"
        class="btn-cancel"
        @click="cancelBadge(previousModal)"
        style="margin-right: 0.25rem"
        >Cancel</b-button
      >
      <b-button
        variant="primary"
        @click="saveBadge(previousModal)"
        style="margin-left: 0.25rem"
        >Save</b-button
      >
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "UploadBadgeModal",
  props: ["previousModal"],
  data() {
    return { croppa: {}, sliderVal: 0, sliderMin: 0, sliderMax: 0 };
  },
  computed: {
    ...mapState("programMembershipTiers", ["badge"]),
  },
  methods: {
    ...mapMutations("programMembershipTiers", ["setBadge"]),
    clearBadge() {
      this.setBadge(null);
      this.croppa.remove();
    },
    onNewBadge() {
      this.sliderVal = this.croppa.scaleRatio;
      this.sliderMin = this.croppa.scaleRatio / 2;
      this.sliderMax = this.croppa.scaleRatio * 2;
    },
    onBadgeSliderChange(e) {
      this.croppa.scaleRatio = +e.target.value;
    },
    onBadgeZoom() {
      this.sliderVal = this.croppa.scaleRatio;
    },
    cancelBadge(modal) {
      this.clearBadge();
      this.$root.$emit("bv::hide::modal", "upload-badge-modal");
      this.$root.$emit("bv::show::modal", modal);
    },
    saveBadge(modal) {
      const badgeDataUrl = this.croppa.generateDataUrl();

      this.setBadge(badgeDataUrl ? badgeDataUrl : null);
      this.$root.$emit("bv::hide::modal", "upload-badge-modal");
      this.$root.$emit("bv::show::modal", modal);
    },
  },
};
</script>

<style>
</style>